import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import ReinforcementOverlay from './ReinforcementOverlay'

interface ReinforcementContainerProps {
  backgroundImage: string
}

export const ReinforcementContainer = styled.div<ReinforcementContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(0, 0);
  width: calc(100dvw - (${props => props.theme.spacing.mediumSmall} * 2));
  height: calc(100dvh - (${props => props.theme.spacing.medium} * 2));
  padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.mediumSmall};
  background: url(${props => props.backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center top;
  opacity: 1;
  overflow: auto;
  z-index: 100;

  @media (min-width: ${props => props.theme.breakpoints.mobile}) {
    top: 0;
    right: 0;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 20px);
    max-width: 506px;
    max-height: min(700px, 88dvh);
    height: calc(100dvh - (${props => props.theme.spacing.medium} * 2) - ${props => props.theme.spacing.mediumSmall});
    overflow: hidden;
    border-radius: ${props => props.theme.spacing.small};
  }
`

interface ReinforcementScreenProps {
  backgroundImage: string
  title: ReactElement
  description: ReactElement
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const ReinforcementScreenContainer: FC<ReinforcementScreenProps> = ({ backgroundImage, title, description, onContinue }) => {
  return (
    <ReinforcementContainer backgroundImage={backgroundImage}>
      <ReinforcementOverlay
        title={title}
        description={description}
        onNext={onContinue}
      />
    </ReinforcementContainer>
  )
}

export default ReinforcementScreenContainer
